/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
 
export const parseJSONSafely = (str: string) => {
    if (typeof str !== 'string') return {};
    try {
        return JSON.parse(str);
    } catch {
        return {};
    }
};
 
export const checkWhiteList = (userEmail: string, whiteListFlag: { emails: string[] }) => {
    if (userEmail && whiteListFlag?.emails && whiteListFlag?.emails?.length) {
        return whiteListFlag.emails.includes(userEmail);
    }
    return false;
};
 
export const getPageType = (path: string) => {
    if (typeof path === 'string' && path?.includes('/p/')) {
        return 'pdp';
    } else if (typeof path === 'string' && path?.includes('/c/')) {
        return 'collection';
    } else {
        return 'general';
    }
};
 
export const getDeviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return 'tablet';
    }
    if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        return 'mobile';
    }
    return 'desktop';
};
 
// Browser detection code taken from https://developer.mozilla.org/en-US/docs/Web/API/Window/navigator
export const getBrowser = () => {
    let sBrowser = '';
    const sUsrAg = typeof window !== 'undefined' ? navigator.userAgent : '';
 
    // The order matters here, and this may report false positives for unlisted browsers.
    if (sUsrAg.indexOf('Firefox') > -1 || sUsrAg.indexOf('FxiOS') > -1) {
        sBrowser = 'Mozilla Firefox';
        // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
        // Android
        // "Mozilla/5.0 (Android 11; Mobile; rv:85.0) Gecko/85.0 Firefox/85.0"
        // iOS
        // "Mozilla/5.0 (iPhone; CPU OS 14_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) FxiOS/31.0 Mobile/15E148 Safari/605.1.15"
    } else if (sUsrAg.indexOf('SamsungBrowser') > -1) {
        sBrowser = 'Samsung Internet';
        // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
        // non Samsung Android
        // Mozilla/5.0 (Linux; Android 11; Mi A3) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/13.2 Chrome/83.0.4103.106 Mobile Safari/537.36
    } else if (sUsrAg.indexOf('AlohaBrowser') > -1) {
        sBrowser = 'Aloha Browser';
        // Android
        // "Mozilla/5.0 (Linux; Android 11; XIAOMI Mi A3 Build/NMF26F) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/83.0.4103.96 Mobile Safari/537.36 AlohaBrowser/3.1.1"
        // iOS
        // "Mozilla/5.0 (iPhone; CPU iPhone OS 14_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 Version/14.4 Safari/605.1.15 AlohaBrowser/3.1.1"
    } else if (sUsrAg.indexOf('UCBrowser') > -1) {
        sBrowser = 'UC Browser';
        // iOS
        // "Mozilla/5.0 (iPhone; CPU iPhone OS 14_4 like Mac OS X; en-US) AppleWebKit/537.51.1 (KHTML, like Gecko) Mobile/18D52 UCBrowser/11.3.5.1203 Mobile"
    } else if (sUsrAg.indexOf('Opera') > -1 || sUsrAg.indexOf('OPR') > -1 || sUsrAg.indexOf('OPT') > -1) {
        sBrowser = 'Opera';
        // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
        // Android
        // "Mozilla/5.0 (Linux; Android 11; Mi A3) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/86.0.4240.198 Mobile Safari/537.36 OPR/61.2.3076.56749"
        // iOS
        // "Mozilla/5.0 (iPhone; CPU iPhone OS 14_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 OPT/2.5.5"
    } else if (sUsrAg.indexOf('Trident') > -1) {
        sBrowser = 'Microsoft Internet Explorer';
        // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
    } else if (sUsrAg.indexOf('Edge') > -1 || sUsrAg.indexOf('EdgiOS') > -1 || sUsrAg.indexOf('EdgA') > -1) {
        sBrowser = 'Microsoft Edge';
        // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
        // Android
        // "Mozilla/5.0 (Linux; Android 11; Mi A3) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/77.0.3865.116 Mobile Safari/537.36 EdgA/46.01.4.5140"
        // iOS
        // "Mozilla/5.0 (iPhone; CPU iPhone OS 14_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.0 EdgiOS/46.1.2 Mobile/15E148 Safari/605.1.15"
    } else if (sUsrAg.indexOf('DuckDuckGo') > -1) {
        sBrowser = 'DuckDuckGo';
        // DuckDuckGo Android
        // "Mozilla/5.0 (Linux; Android 11) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/88.0.4324.93 Mobile DuckDuckGo/5 Safari/537.36"
        // DuckDuckGo iOS
        // "Mozilla/5.0 (iPhone; CPU iPhone OS 14_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.4 Mobile/15E148 DuckDuckGo/7 Safari/605.1.15"
    } else if (sUsrAg.indexOf('Chrome') > -1 || sUsrAg.indexOf('CriOS') > -1) {
        sBrowser = 'Chrome';
        // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
        // Chrome Android
        // "Mozilla/5.0 (Linux; Android 11; Mi A3) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/88.0.4324.93 Mobile Safari/537.36"
        // Chrome iOS
        // "Mozilla/5.0 (iPhone; CPU iPhone OS 14_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/87.0.4280.77 Mobile/15E148 Safari/604.1"
    } else if (sUsrAg.indexOf('Safari') > -1) {
        sBrowser = 'Apple Safari';
        // "Mozilla/5.0 (iPhone; CPU iPhone OS 14_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.0.3 Mobile/15E148 Safari/604.1"
    } else {
        sBrowser = 'unknown';
    }
    return sBrowser;
};
 
export const getOS = () => {
    const ua = navigator.userAgent;
 
    // Windows
    if (ua.indexOf('Windows NT 10.0') !== -1) return 'Windows 10/11'; // Windows 10 and 11
    if (ua.indexOf('Windows NT 6.3') !== -1) return 'Windows 8.1';
    if (ua.indexOf('Windows NT 6.2') !== -1) return 'Windows 8';
    if (ua.indexOf('Windows NT 6.1') !== -1) return 'Windows 7';
    if (ua.indexOf('Windows NT 6.0') !== -1) return 'Windows Vista';
    if (ua.indexOf('Windows NT 5.1') !== -1) return 'Windows XP';
    if (ua.indexOf('Windows NT 5.0') !== -1) return 'Windows 2000';
    if (ua.indexOf('Windows') !== -1) return 'Windows (Other)'; // Generic Windows
 
    // macOS (covers macOS, Mac OS X)
    if (ua.indexOf('Mac OS X') !== -1) {
        // More specific macOS version parsing (optional but good)
        const macMatch = /Mac OS X ([\d._]+)/.exec(ua);
        if (macMatch && macMatch[1]) {
            const version = macMatch[1].replace(/_/g, '.');
            if (version.startsWith('10.0')) return 'macOS Cheetah';
            if (version.startsWith('10.1')) return 'macOS Puma';
            if (version.startsWith('10.2')) return 'macOS Jaguar';
            if (version.startsWith('10.3')) return 'macOS Panther';
            if (version.startsWith('10.4')) return 'macOS Tiger';
            if (version.startsWith('10.5')) return 'macOS Leopard';
            if (version.startsWith('10.6')) return 'macOS Snow Leopard';
            if (version.startsWith('10.7')) return 'macOS Lion';
            if (version.startsWith('10.8')) return 'macOS Mountain Lion';
            if (version.startsWith('10.9')) return 'macOS Mavericks';
            if (version.startsWith('10.10')) return 'macOS Yosemite';
            if (version.startsWith('10.11')) return 'macOS El Capitan';
            if (version.startsWith('10.12')) return 'macOS Sierra';
            if (version.startsWith('10.13')) return 'macOS High Sierra';
            if (version.startsWith('10.14')) return 'macOS Mojave';
            if (version.startsWith('10.15')) return 'macOS Catalina';
            if (version.startsWith('11.')) return 'macOS Big Sur';
            if (version.startsWith('12.')) return 'macOS Monterey';
            if (version.startsWith('13.')) return 'macOS Ventura';
            if (version.startsWith('14.')) return 'macOS Sonoma';
            // Add more as new versions are released
            return `macOS ${version}`;
        }
        return 'macOS'; // Generic macOS if version not found
    }
 
    // Android
    if (ua.indexOf('Android') !== -1) {
        return 'Android';
    }
 
    // iOS (iPad, iPhone, iPod)
    if (/(iPad|iPhone|iPod).*OS ([\d_.]+)/.test(ua)) {
        const iOSMatch = /(iPad|iPhone|iPod).*OS ([\d_.]+)/.exec(ua);
        if (iOSMatch && iOSMatch[2]) {
            const version = iOSMatch[2].replace(/_/g, '.');
            if (ua.indexOf('iPad') !== -1) return `iPadOS ${version}`;
            return `iOS ${version}`;
        }
        if (ua.indexOf('iPad') !== -1) return 'iPadOS';
        return 'iOS';
    }
 
    // Linux (various distributions are harder to distinguish reliably)
    if (ua.indexOf('Linux') !== -1) return 'Linux'; // Could be Ubuntu, Fedora, etc.
 
    // Chrome OS
    if (ua.indexOf('CrOS') !== -1) return 'Chrome OS';
 
    // BlackBerry
    if (ua.indexOf('BlackBerry') !== -1 || ua.indexOf('BB10') !== -1) return 'BlackBerry OS';
 
    // Windows Phone
    if (ua.indexOf('Windows Phone') !== -1) return 'Windows Phone';
 
    // Catch-all for others (e.g., smart TVs, gaming consoles, less common OSes)
    return 'Unknown OS';
};
